/* eslint-disable no-unused-vars */
import React from 'react'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import { HiChevronRight } from 'react-icons/hi';
import folder from 'static/images/svg/folder.svg';
import Button from 'shared/Button';
import Loader from 'shared/Loader';
import { getUserOrderedEventsAction } from 'actions/orderActions';
import refresh from 'static/images/refresh.png'
import '../../static/style/orders.scss';

function OrderEventListing(props) {
    const {
        backToOrder,
        orderNumber,
        orderDetailsFunc,
        handleEventSelection,
        history,
        folderToOrderDetailsFunc,
        fileScroll
    } = props

    const dispatch = useDispatch()
    const [ isLoading, setIsLoading ] = useState(false)
    const [ eventData, setEventData ] = useState([])

    const fetchEventData = () => {
        setIsLoading(true)
        dispatch(getUserOrderedEventsAction(orderNumber))
            .then((response) => {
                setIsLoading(false)
                if (response.statusCode === 200) {
                    setEventData(response.data.event_list  || [])
                }
            })
            .catch((error) => {
                setIsLoading(false)
                console.error('Error fetching events:', error)
            })
    }
    useEffect(() => {
        if (orderNumber) {
            fetchEventData()
        }
    }, [ dispatch, orderNumber ])

    const refreshHandler = () => {
        fetchEventData()
    }

    const handleEventClick = (event) => {
        if (handleEventSelection) {
            handleEventSelection(event)
        }
    }

    return (
        <>
            <div className="event-header pb-3">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="heading">Events</div>
                    <div>
                        <div className='d-flex align-items-center'>
                            <Button
                                className="create-btn"
                                handleSubmit={ () => refreshHandler() }
                                buttonName="Refresh"
                                imageParam={ <img src={ refresh } alt="refresh-img" className="edit-img" /> }
                            />
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-between align-items-center'>
                    { window.location.pathname === '/preorders' ? (
                        <Breadcrumb className="text-start mt-3" separator={ (<HiChevronRight className="breadcrumb-arrow" />) }>
                            <Breadcrumb.Item className="pointer" onClick={ () => orderDetailsFunc() }>Pre Order</Breadcrumb.Item>
                            <Breadcrumb.Item className="pointer">{ orderNumber }</Breadcrumb.Item>
                            <Breadcrumb.Item>Events</Breadcrumb.Item>
                        </Breadcrumb>
                    ) :
                        window.location.pathname === '/orders' ? (
                            <Breadcrumb className="text-start mt-3" separator={ (<HiChevronRight className="breadcrumb-arrow" />) }>
                                <Breadcrumb.Item className="pointer" onClick={ () => backToOrder() }>Orders</Breadcrumb.Item>
                                <Breadcrumb.Item className="pointer" onClick={ () => orderDetailsFunc() }>Order Details</Breadcrumb.Item>
                                <Breadcrumb.Item>Events</Breadcrumb.Item>
                            </Breadcrumb>
                        ) :
                            window.location.pathname === '/customer-accounts' ? (
                                <Breadcrumb className="text-start mt-3" separator={ (<HiChevronRight className="breadcrumb-arrow" />) }>
                                    <Breadcrumb.Item className="pointer">Customers</Breadcrumb.Item>
                                    <Breadcrumb.Item className="pointer" onClick={ () => orderDetailsFunc() }>Order Details</Breadcrumb.Item>
                                    <Breadcrumb.Item>Events</Breadcrumb.Item>
                                </Breadcrumb>
                            ) : (
                                <Breadcrumb className="text-start mt-3" separator={ (<HiChevronRight className="breadcrumb-arrow" />) }>
                                    <Breadcrumb.Item>Orders</Breadcrumb.Item>
                                    <Breadcrumb.Item>Events</Breadcrumb.Item>
                                </Breadcrumb>
                            )
                    }
                </div>
            </div>

            {isLoading && <div className="mt-5"><Loader /></div>}

            {!isLoading && (
                <div className="event-folder-wrapper pt-4">
                    <div className="d-flex flex-wrap" id='folderContainer'>
                        { eventData.map((event, index) => (
                            <div key={ event.id || index } className="position-relative">
                                <div
                                    className="card pointer"
                                    onClick={ () => handleEventClick(event) }
                                >
                                    <div className="card-header d-flex align-items-center">
                                        <div className="img-wrapper">
                                            <img src={ folder } alt="folder-img" width="20" className="me-2" />
                                        </div>
                                        <div className="card-heading">
                                            { event.event_code }
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text"><br /></p>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {(eventData.length === 0 && !isLoading) && (
                            <p className="m-auto mt-5">No events found</p>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

OrderEventListing.propTypes = {
    backToOrder: PropTypes.func,
    orderNumber: PropTypes.string,
    orderDetailsFunc: PropTypes.func,
    handleEventSelection: PropTypes.func, // Updated prop name
    history: PropTypes.object,
    folderToOrderDetailsFunc: PropTypes.func,
    fileScroll: PropTypes.object
}

export default OrderEventListing